import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import CheckOff from '../../icons/CircleCheckOff';
import CheckOn from '../../icons/CircleCheckOn';
import Button from '../Button';


const CheckCircle = ({ label, style, labelStyle, checked, onPress, className}, ref) => {
    const [isChecked, setChecked] = useState(false)
    const handleCheck = (value)=>{
        onPress && onPress()
       // setChecked(value)
    }
    
    useImperativeHandle(ref, () => ({
        handleCheck: handleCheck
    }))

    useEffect(()=>{
        //if(checked) setChecked(checked)
    }, [checked])
    return (
        <Button
            style={{...styles.row, ...style}}
            onClick={()=> handleCheck(!checked)}
            className={className}
        >
            {!checked ? <CheckOff /> :  <CheckOn />}
            <label style={{...styles.checkBoxLabel, ...labelStyle}} className='body_15_medium'>{label}</label>
        </Button>
    )
}

const styles = {
    row: {
        flexDirection: 'row',
        display: 'flex'
    },
    checkBoxLabel: {
        fontSize: 16,
        letterSpacing: 0,
        color: "#fff",
        marginLeft: 6
    },
}
export default forwardRef(CheckCircle);